// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2mWt6","dragIcon":"SortableItem_dragIcon__23ahJ","disabled":"SortableItem_disabled__2p_Tf"};